import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SectorStayDetailsComponent } from './sector-stay-details.component';
import { RatingModule } from 'libraries/component/rating/rating.module';
import { AddressModule } from 'libraries/component/address/address.module';
import { SectorTravellerModule } from '../../shared/components/sector-traveller/sector-traveller.module';
import { MealPlanModule } from 'libraries/component/meal-plan/meal-plan.module';
import { CancellationConditionsModule } from 'libraries/hotel/components/cancellation-conditions/cancellation-conditions.module';
import { RoomInformationsModule } from 'libraries/hotel/components/room-informations/room-informations.module';
import { RoomService } from 'libraries/hotel/services/room/room.service';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { DescriptionModule } from 'libraries/hotel/components/description/description.module';
import { PropertyDescriptionModule } from './components/property-description/property-description.module';
import { PropertyDescriptionComponent } from './components/property-description/property-description.component';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { PriceModule } from 'libraries/component/price/price.module';
import { PriceWithConversionModule } from 'libraries/component/price-with-conversion/price-with-conversion.module';
import { TelephoneModule } from "libraries/component/telephone/telephone.module";
import { HasTravellersInfosPipe } from "./pipes/has-travellers-infos/has-travellers-infos.pipe";
import { TravellerQuantityModule } from "./components/traveller-quantity/traveller-quantity.module";
import { SupplementPriceModule } from "./components/supplement-price/supplement-price.module";
import { ReferencesModule } from "../../shared/components/references/references.module";
import { ImportantInformationModule } from "./components/important-information/important-information.module";
import { PricePerRoomModule } from "./components/price-per-room-modale/price-per-room.module";
import { PricePerRoomComponent } from "./components/price-per-room-modale/price-per-room-component";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { PropertyDescriptionService } from "libraries/component/booking-information/components/sectors/components/sectors-stay/property-description.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {PermissionModule} from "../../../../../../../permission/permission.module";
import { DescriptionHelperModule } from "libraries/service/description-helper/description-helper.module";
import {GetMainCurrencyModule} from "../../../../../../../service/get-main-currency/get-main-currency.module";

@NgModule({
    imports: [
        AddressModule,
        BtnModule,
        CancellationConditionsModule,
        CommonModule,
        DescriptionModule,
        ImportantInformationModule,
        LoaderModule,
        MatDialogModule,
        MealPlanModule,
        NotificationModule,
        PriceModule,
        PricePerRoomModule,
        PriceWithConversionModule,
        PropertyDescriptionModule,
        RatingModule,
        ReferencesModule,
        RoomInformationsModule,
        SectorTravellerModule,
        SupplementPriceModule,
        TelephoneModule,
        TravellerQuantityModule,
        HostAliasPipeModule,
        FontAwesomeModule,
        PermissionModule,
        DescriptionHelperModule,
        GetMainCurrencyModule
    ],
    exports: [
        SectorStayDetailsComponent,
    ],
    declarations: [
        HasTravellersInfosPipe,
        SectorStayDetailsComponent,
    ],
    providers: [
        HelperService,
        RoomService,
        PropertyDescriptionService,
    ],
    entryComponents: [
        PropertyDescriptionComponent,
        PricePerRoomComponent,
    ]
})
export class SectorStayDetailsModule {}
